<template>
  <b-modal title="Alta distribuidor" cancel-title="Cerrar" ok-title="Alta" class="modal-success" v-model="open" @ok.prevent="altaDistribuidor" @hidden="clear">
       <b-form-group id="rfc" description="RFC del distribuidor" label="RFC" 
        :feedback="errors.Rfc | fetchErrors" 
        :state="RFCHasErrors"
        >
        <b-form-input type="text" v-mask="['AAAA######XXX','AAA######XXX']" id="rfc" :state="RFCHasErrors" v-model.trim="Rfc"></b-form-input>
      </b-form-group>
      <b-form-group id="email" description="Correo electrónico del distribuidor" label="Correo electrónico" 
        :feedback="errors.Correo | fetchErrors" 
        :state="CorreoHasErrors"
        >
        <b-form-input type="email"  id="email" :state="CorreoHasErrors" v-model.trim="draft.Correo"></b-form-input>
      </b-form-group>
       <b-form-group id="contacto" description="Nombre nompleto de contacto del distribuidor" label="Contacto" 
        :feedback="errors.Contacto | fetchErrors" 
        :state="ContactoHasErrors"
        >
        <b-form-input type="text"  id="contacto" :state="ContactoHasErrors" v-model.trim="draft.Contacto"></b-form-input>
      </b-form-group>
      <div class="row">
        <div class="col-md-6">
          <b-form-group id="telefono" description="Teléfono del distribuidor" label="Teléfono" 
            :feedback="errors.Telefono | fetchErrors" 
            :state="CorreoHasErrors"
            >
            <b-form-input type="text"  id="telefono" :state="TelefonoHasErrors" v-model.trim="draft.Telefono"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-6">
           <b-form-group id="vigencia" description="Vigencia de los timbres del distribuidor" label="Vigencia" 
            :feedback="errors.Vigencia | fetchErrors" 
            :state="VigenciaHasErrors"
            >
            <b-form-input type="date"  id="vigencia" :state="VigenciaHasErrors" placeholder="DD/MM/YYYY" v-model.trim="draft.Vigencia"></b-form-input>
          </b-form-group>
         </div>
         <div class="col-md-6">
          <b-form-group id="Timbres" description="Timbres ha asignar al distribuidor" label="Timbres" 
            :feedback="errors.Timbres | fetchErrors" 
            :state="TimbresHasErrors"
            >
            <b-form-input type="number"  v-mask="'#########'" id="timbres" :state="TimbresHasErrors" min="1" v-model.trim="draft.Timbres"></b-form-input>
          </b-form-group>
          </div>
          <div class="col-md-6">
             <b-form-group id="Factura" description="Número de factura de compra" label="Número de factura" 
            :feedback="errors.Factura | fetchErrors" 
            :state="FacturaHasErrors"
            >
            <b-form-input type="text"  id="Factura" :state="FacturaHasErrors" min="1" v-model.trim="draft.Factura"></b-form-input>
          </b-form-group>
          </div>
          <div class="col-md-6">
              <b-form-group id="grupos" description="Habilitar grupos." label="Grupos">
                  <c-switch type="3d" variant="primary" :checked="this.draft.Grupos"/>
              </b-form-group>
          </div>
      </div>
      <div slot="modal-footer" class="w-100">
          <div class="float-right">
              <b-btn variant="secondary" @click="open=false">
                  Cerrar
              </b-btn>
              <template v-if="loading === false">
                  <b-btn :disable="loading" variant="primary" @click="altaDistribuidor">
                      Alta
                  </b-btn>
              </template>
          </div>
      </div>
    </b-modal>
</template>
<script>
import EventBus from '@/event-bus.js'
import cSwitch from '@/components/Switch'

export default {
  name: 'Alta',
  components: {
    cSwitch
  },
  data () {
    return {
      errors: [],
      open: false,
      loading: false,
      draft: {
        Correo: '',
        Vigencia: this.$moment().add('1', 'year').format('YYYY-MM-DD'),
        Asignar: '',
        Rfc: '',
        Contacto: null,
        Telefono: null,
        Factura: 1,
        Timbres: 1,
        Estatus: true,
        Grupos: 0
      }
    }
  },
  computed: {
    Rfc: {
      set (value) {
        this.draft.Rfc = (value) ? value.toUpperCase() : value
      },
      get () {
        return (this.draft.Rfc) ? this.draft.Rfc.toUpperCase() : this.draft.Rfc
      }
    },
    distribuidores () {
      return this.$store.state.distribuidores
    },
    changeGrupos (grupos) {
      this.draft.Grupos = grupos
    },
    CorreoHasErrors () {
      let message = (typeof this.errors.Correo === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    VigenciaHasErrors () {
      let message = (typeof this.errors.Vigencia === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    TimbresHasErrors () {
      let message = (typeof this.errors.Timbres === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    FacturaHasErrors () {
      let message = (typeof this.errors.Factura === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    RFCHasErrors () {
      let message = (typeof this.errors.Rfc === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    ContactoHasErrors () {
      let message = (typeof this.errors.Contacto === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    TelefonoHasErrors () {
      let message = (typeof this.errors.Telefono === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    Grupos () {
      return (this.draft.Grupos === 1)
    }
  },
  filters: {
    fetchErrors (errors) {
      return (typeof errors === 'undefined') ? '' : (errors.length > 0) ? errors[0] : ''
    }
  },
  methods: {
    clear () {
      this.draft = {
        Correo: '',
        Vigencia: this.$moment().add('1', 'year').format('YYYY-MM-DD'),
        Asignar: '',
        Rfc: '',
        Contacto: null,
        Telefono: null,
        Factura: 1,
        Timbres: 1,
        Estatus: true,
        Grupos: false
      }
      this.open = false
      this.errors = []
    },
    fetchDistribuidores () {
      this.$store.dispatch('fetchDistribuidores').then(response => {
        this.$store.commit('distribuidores', response.data)
      })
    },
    altaDistribuidor () {
      let information = this.draft
      if (information.Telefono === '' || information.Telefono === null) {
        delete information.Telefono
      }
      if (information.Contacto === '' || information.Contacto === null) {
        delete information.Contacto
      }
      this.loading = true
      this.$store.dispatch('altaDistribuidor', information).then(response => {
        this.clear()
        this.fetchDistribuidores()
        this.$swal({
          position: 'top-right',
          type: 'success',
          title: 'Se creo con exito al Distribuidor',
          showConfirmButton: false,
          timer: 1500
        })
      }, errors => {
        this.open = true
        this.loading = false
        console.log(errors.response.data)
        this.errors = errors.response.data
      })
    }
  },
  mounted () {
    this.clear()
  },
  created () {
    this.draft.Grupos = false
    EventBus.$on('change', data => {
      this.draft.Grupos = data
    })
    EventBus.$on('abrirModalAlta', enablerModal => {
      this.open = enablerModal
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Distribuidores/Crud/Alta.vue